import { useEffect } from "react";
import useMeasure from "react-use-measure";

type Props = {
  children: React.ReactNode;
  tooltipWidth: number;
  onHeightChange: (height: number) => void;
};

export default function Component({ children, tooltipWidth, onHeightChange }: Props) {
  const [ref, { height }] = useMeasure();
  const rectangleShift = 0;

  useEffect(() => {
    onHeightChange(height);
  }, [height]);

  return (
    <div ref={ref}>
      {/* rectangle */}
      <div
        style={{
          top: -(height / 2),
          width: tooltipWidth,
          left: rectangleShift,
        }}
        className="relative rounded bg-background text-foreground border-border border p-1 shadow"
      >
        <div className="relative">{children}</div>
      </div>
    </div>
  );
}
